import { render, staticRenderFns } from "./TypeSacrifice.vue?vue&type=template&id=ec571984&scoped=true&"
import script from "./TypeSacrifice.vue?vue&type=script&lang=js&"
export * from "./TypeSacrifice.vue?vue&type=script&lang=js&"
import style0 from "./TypeSacrifice.vue?vue&type=style&index=0&id=ec571984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec571984",
  null
  
)

export default component.exports